export class UserSearch {
  public email: string;
  public roles: string[];
  public blocked: boolean;
  public carrierId: string;
  public carrierName: string;
  public subcontractorId: string;
  public subcontractorName: string;

  static fromDto(u: any): UserSearch {
    if (!u) {
      return null;
    }
    const user = new UserSearch();
    user.email = u.email;
    user.roles = u.roles;
    user.blocked = u.blocked;
    user.carrierId = u.carrierId;
    user.carrierName = u.carrierName;
    user.subcontractorId = u.subcontractorId;
    user.subcontractorName = u.subcontractorName;
    return user;
  }
}
